import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import gallary from "../../../../Utils/Images/Gallerywhite.png";
import CustomInput from "../../../../Components/input/CustomInput";
import { GetSingleProduct } from "../../../../APIs/Function/Product/GetSingleProduct";
import { handleUpdateProduct } from "../../../../APIs/Function/Product/EditProduct";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Loader2 from "../../../../Components/Loader/Loader2";
import { GetProductCategory } from "../../../../APIs/Function/ProductCategory/GetProductCategory";

const EditProduct = () => {
  const validationSchema = Yup.object().shape({
    product_name: Yup.string().required("Product Name is required"),
    description: Yup.string().required("Description is required"),
    actual_price: Yup.number()
      .min(1, "Actual Price must be greater than  0")
      .required("Actual Price is required"),
    available_stock: Yup.number()
      .min(1, "Stock must be greater than  0")
      .required("Available Stock is required"),
    discount_price: Yup.number()
      .min(1, "Price must be greater than  0")
      .required("Discounted Price is required"),
  });
  const [actualPriceError, setActualPriceError] = useState("");
  const [discountPriceError, setDiscountPriceError] = useState("");
  const [availableStockError, setAvailableStockError] = useState("");

  const { id } = useParams();
  const [previewImage, setPreviewImage] = useState([]);
  const [singleProduct, setSingleProduct] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [imagea, setImagea] = useState([]);
  const [loadinga, setLoadinga] = useState(false);
  const [removedImages, setRemovedImages] = useState([]);
  const [imagesRemoved, setImagesRemoved] = useState(false);
  const [category, setCategory] = useState([]);

  const initialFormData = {
    product_name: "",
    description: "",
    actual_price: "",
    available_stock: "",
    discount_price: "",
    image: "",
    product_category: "",
  };
  const [formData, setFormData] = useState({
    product_name: "",
    description: "",
    actual_price: "",
    available_stock: "",
    discount_price: "",
    image: "",
    product_category: "",
  });

  const removeMainImage = (index) => {
    if (Array.isArray(singleProduct.product_images)) {
      const updatedImages = [...singleProduct.product_images];
      if (index >= 0 && index < updatedImages.length) {
        const removedImage = updatedImages.splice(index, 1)[0];
        setSingleProduct({
          ...singleProduct,
          product_images: updatedImages,
        });
        if (removedImage.id) {
          setRemovedImages([...removedImages, removedImage.id]);
          setImagesRemoved(true);
        }

        const updatedFormDataImages = [...formData.image];
        updatedFormDataImages.splice(index, 1);
        setFormData({
          ...formData,
          image: updatedFormDataImages,
        });
      }
    }
  };

  const handleEditProduct = async () => {
    try {
      setLoadinga(true);
      let res = await GetSingleProduct(id);
      setSingleProduct(res.r);
      setFormData({
        ...formData,
        product_name: res.r.product_name,
        description: res.r.description,
        actual_price: res.r.actual_price,
        available_stock: res.r.available_stock,
        discount_price: res.r.discount_price,
        image: res.r.product_images,
        id: id,
      });
      setLoadinga(false);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (+formData.discount_price > +formData.actual_price) {
      alert("Discounted price should be less then actual price");
    } else {
      if (formData?.image?.length) {
        try {
          await validationSchema.validate(formData, { abortEarly: false });
          setLoading(true);
          const payload = {
            id,
            ...formData,
          };
          if (imagesRemoved) {
            payload.remove_photos = removedImages;
          }
          await handleUpdateProduct(payload);
          setLoading(false);
          alert("Product Edited Successfully");
          navigate("/product");
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
            const errorMessages = error.inner.map((err) => err.message);
            alert(errorMessages.join("\n"));
          } else {
            console.log(error);
          }
        }
      } else {
        alert("Please Upload Image");
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "product_name" || name === "description") {
      setFormData({
        ...formData,
        [name]: value,
      });
    } else {
      let numericValue = parseFloat(value);

      if (name === "discount_price") {
        // Limit the number of decimal places to two
        numericValue = parseFloat(numericValue.toFixed(2));
      }
      if (name === "actual_price") {
        // Limit the number of decimal places to two
        numericValue = parseFloat(numericValue.toFixed(2));
      }

      setFormData({
        ...formData,
        [name]: numericValue,
      });

      switch (name) {
        case "actual_price":
          if (numericValue < 0) {
            setActualPriceError("Actual Price cannot be negative");
          } else {
            setActualPriceError("");
          }
          break;
        case "discount_price":
          if (numericValue < 0) {
            setDiscountPriceError("Discounted Price cannot be negative");
          } else {
            setDiscountPriceError("");
          }
          break;
        case "available_stock":
          if (numericValue < 0) {
            setAvailableStockError("Available Stock cannot be negative");
          } else {
            setAvailableStockError("");
          }
          break;
        default:
          break;
      }
    }
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    setImagea(selectedFiles);
    setFormData({
      ...formData,
      image: selectedFiles,
    });
    const objectURLs = [];
    for (let i = 0; i < selectedFiles.length; i++) {
      const objectURL = URL.createObjectURL(selectedFiles[i]);
      objectURLs.push(objectURL);
    }
    setPreviewImage(objectURLs);
    previewImage.forEach((objectURL) => URL.revokeObjectURL(objectURL));
  };

  useEffect(() => {
    handleEditProduct();
  }, []);

  const removePreviewImage = (index) => {
    const updatedPreviewImage = [...previewImage];
    updatedPreviewImage.splice(index, 1);
    setPreviewImage(updatedPreviewImage);
  };
  const getcategory = async () => {
    try {
      let res = await GetProductCategory();
      console.log(res.r);
      setCategory(res.r);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getcategory();
  }, []);
  return (
    <>
      {loadinga ? (
        <Box sx={{ mt: "25%" }}>
          <Loader2 />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={`/productdetails/${id}`}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Edit Product
              </Typography>
            </Box>
            <Box>
              <CustomButton
                onClick={handleSubmit}
                sx={{
                  width: { xs: "40px", md: "50px", lg: "80px" },
                  height: { xs: "10px", md: "50px", lg: "50px " },
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              >
                {loading ? <CircularProgress></CircularProgress> : "Save"}
              </CustomButton>
            </Box>
          </Box>
          <Box
            sx={{
              p: 2,
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center ",
            }}
          >
            {/* Form */}
            <Box
              sx={{
                mt: "10px",
                border: "1px solid #E8E8E8",
                width: "45%",
                boxSizing: "border-box",
                p: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between ",
                  alignItems: "center",
                  boxSizing: "border-box",
                  p: 1,
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: 400,
                      fontSize: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    Gallary
                  </Typography>
                </Box>
                <Box>
                  <label htmlFor="file-input">
                    <Box
                      sx={{
                        display: "flex",
                        bgcolor: "#000000",
                        height: "50px",
                        width: "100%",
                        gap: "5px ",
                        alignItems: "center",
                        borderRadius: "5px",
                        p: 2,
                        boxSizing: "border-box",
                        cursor: "pointer",
                        transition: "transform 0.3s",
                        "&:hover": {
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontFamily: "inter",
                          fontWeight: 400,
                          fontSize: "16px",
                          lineHeight: "16px",
                        }}
                      >
                        Upload Image
                      </Typography>
                      <Box sx={{ width: "25px", height: "25px" }}>
                        <img width={"100%"} src={gallary} alt="gallary" />
                      </Box>
                    </Box>
                  </label>
                  <input
                    accept="image/*"
                    type="file"
                    id="file-input"
                    multiple
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: "20px",
                  p: "5%",
                  boxSizing: "border-box",
                  width: "100%",
                  flexWrap: "wrap",
                }}
              >
                {singleProduct?.product_images?.map((e, i) => (
                  <Box
                    key={i}
                    sx={{ width: "150px", ml: "10px", height: "150px" }}
                  >
                    <Box
                      sx={{ position: "relative" }}
                      onClick={() => removeMainImage(i)}
                    >
                      <HighlightOffIcon
                        sx={{
                          ml: "30%",
                          mt: "5px",
                          cursor: "pointer",
                          position: "absolute",
                        }}
                      />
                    </Box>

                    <img
                      width={"100%"}
                      height={"100%"}
                      src={`https://api.qhealth.com.au/upload/images/${e.p_images}`}
                      alt=""
                    />
                  </Box>
                ))}
              </Box>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {previewImage
                  ? previewImage.map((e, i) => (
                      <Box key={i} sx={{ width: "150px", height: "150px" }}>
                        <HighlightOffIcon
                          onClick={() => removePreviewImage(i)}
                          sx={{
                            cursor: "pointer",
                            position: "absolute",
                            ml: "150px",
                            mt: "-15px",
                          }}
                        />
                        <img
                          style={{ borderRadius: "10px" }}
                          width={"100%"}
                          height={"100%"}
                          src={e}
                          alt="preview"
                        />
                      </Box>
                    ))
                  : ""}
              </Box>
            </Box>
            <Box sx={{ width: "45%" }}>
              <Container maxWidth="sm" sx={{ mt: "10px" }}>
                <form>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Product Name"
                        name="product_name"
                        value={formData?.product_name}
                        onChange={handleInputChange}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Description"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        fullWidth
                        multiline
                        rows={4}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth required>
                        <InputLabel
                          sx={{
                            backgroundColor: "#FFF",
                          }}
                        >
                          Product Category
                        </InputLabel>
                        <Select
                          name="product_category" // Set a name for the Select component
                          value={formData.product_category} // Use the correct value from your form data
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              product_category: e.target.value,
                            })
                          }
                          sx={{ textAlign: "left" }}
                        >
                          {category?.map((e, i) => (
                            <MenuItem key={i} value={e.id}>
                              {e.category}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Actual Price"
                        name="actual_price"
                        type="number"
                        value={formData.actual_price}
                        onChange={handleInputChange}
                        fullWidth
                        required
                        error={actualPriceError !== ""}
                        helperText={actualPriceError}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Discounted Price"
                        name="discount_price"
                        type="number"
                        value={formData.discount_price}
                        onChange={handleInputChange}
                        fullWidth
                        required
                        error={discountPriceError !== ""}
                        helperText={discountPriceError}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Available Stock"
                        name="available_stock"
                        value={formData.available_stock}
                        type="number"
                        onChange={handleInputChange}
                        fullWidth
                        required
                        error={availableStockError !== ""}
                        helperText={availableStockError}
                      />
                    </Grid>
                  </Grid>
                </form>
              </Container>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default EditProduct;
